import axios from "src/lib/axios";

export const getAllLogs = ({
  module = null,
  action = null,
  action_name = null,
  action_by = null,
  start_date = null,
  end_date = null,
  page = null,
  page_size = null,
}) => {
  return axios.get(`/logs`, {
    params: {
      module: module,
      action: action,
      action_name: action_name,
      action_by: action_by,
      start_date: start_date,
      end_date: end_date,
      page: page,
      page_size: page_size,
    },
  });
};
